import { instance } from "./base.api";

const endpoint = "/proveedores";

export const proveedores = {
  getAll: (page: number = 1, limit: number = 1000) => {
    return instance.get(`${endpoint}?page=${page}&limit=${limit}`);
  },
  getById: (id: number) => {
    return instance.get(`${endpoint}/${id}`);
  },
};
